<template lang="pug">
.customer-detail-header.d-flex
  img.rounded-circle(v-if="!isCompact" :src='data.image' height='128' width='128')
  CustomerPicture(v-else :imgSrc="data.image" :grade="data.grade")
  .detail.flex-fill.ml-4(:class="{'is-compact': isCompact, 'mt-2': !isCompact}")
    .title {{ data.name }}
    .address {{ data.address }}

    .customer-data(:class="{'mt-1': isCompact, 'mt-3': !isCompact}")
      .item.w-50
        .key เบอร์ติดต่อ
        .value {{ data.phone }}

    .customer-data.mt-3(v-if='showUnpaid && data.account')
      .item.w-50
        .key รายการครบกำหนดชำระ
        .value.red
          | {{ data.account.outstanding_bills_75days }} รายการ
      .item.w-50
        .key ยอดค้างชำระ
        .value.red
          | {{ data.account.outstanding_balance | currency }}
    .big-grade(
      v-if='data.grade'
      :class="{'d-none': isCompact}"
    )
      | {{ data.grade.toUpperCase() }}
</template>

<script>
import CustomerPicture from './CustomerPicture.vue';

export default {
  props: {
    data: {
      default: {
        image: '',
      },
    },
    showUnpaid: {
      default: true,
    },
    isCompact: {
      default: false,
    },
  },
  components: {
    CustomerPicture,
  },
};
</script>

<style lang="scss">
.customer-detail-header {
  // ...
  .detail {
    position: relative;
    .big-grade {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 140px;
      font-weight: 500;
      color: var(--primary);
      opacity: 0.1;
    }
    .title {
      font-size: 24px;
    }
    .address {
      font-size: 17px;
    }
    &.is-compact {
      .title { font-size: 20px; }
      .address { font-size: 14px; }
    }
  }
}

.customer-data {
  display: flex;
  .item {
    .key {
      font-size: 13px;
      opacity: 0.5;
      letter-spacing: 1px;
    }
    .value {
      font-size: 17px;
      &.red {
        color: #E11A1A;
        font-weight: 500;
      }
    }
  }
}
</style>
